export default "__VITE_ASSET__A01VO6gk__"